import { FC } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Flex } from 'antd'
import { CarrierOneCapabilities } from './CarrierOneCapabilities'
import { CarrierOneEquipment } from './CarrierOneEquipment'
import { CarrierOneDeviceInstallation } from './CarrierOneDeviceInstallation'
import { CarrierOneInspections } from './CarrierOneInspections'

const SUB_TABS = [
	{ hash: '#inventory', label: 'Capabilities' },
	{ hash: '#inventory-equipment', label: 'Equipment' },
	{ hash: '#inventory-device', label: 'IoT Device' },
	{ hash: '#inventory-inspections', label: 'Inspections' }
] as const

export const CarrierOneInventory: FC<{ carrierId: number }> = ({
	carrierId
}) => {
	const navigate = useNavigate()
	const { hash } = useLocation()

	return (
		<Flex style={{ height: '100%' }} gap={10} vertical>
			{/* sub-navigation */}
			<Flex
				align="center"
				style={{
					width: '100%',
					height: 40,
					minHeight: 40,
					backgroundColor: '#647D99',
					fontWeight: 'bold',
					gap: 1,
					borderRadius: '6px',
					overflow: 'hidden'
				}}>
				{SUB_TABS.map(({ hash: subHash, label }) => {
					const active = hash === subHash
					return (
						<Flex
							key={subHash}
							align="center"
							justify="center"
							style={{
								flex: 1,
								fontSize: 15,
								cursor: 'pointer',
								color: active ? '#fff' : '#A4B1BE',
								backgroundColor: active
									? '#364F69'
									: '#4F6781',
								height: 40
							}}
							onClick={() => navigate(subHash)}>
							{label}
						</Flex>
					)
				})}
			</Flex>

			{/* content */}
			<div
				style={{
					overflow: 'auto',
					flex: 1,
					paddingBottom: 8
				}}>
				{hash === '#inventory' && (
					<CarrierOneCapabilities carrierId={carrierId} />
				)}
				{hash === '#inventory-equipment' && (
					<CarrierOneEquipment carrierId={carrierId} />
				)}
				{hash === '#inventory-device' && (
					<CarrierOneDeviceInstallation
						carrierId={carrierId}
					/>
				)}
				{hash === '#inventory-inspections' && (
					<CarrierOneInspections carrierId={carrierId} />
				)}
			</div>
		</Flex>
	)
}
